/** U+FEFF (byte order mark). Kept as a number so no invisible character lives in this file. */
const BOM_CODE = 0xfeff;

/** RFC 4180 quoting: wrap when the cell has a comma, quote, CR or LF; double embedded quotes. */
export function csvCell(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function toCsv(rows: string[][]): string {
  return rows.map((r) => r.map(csvCell).join(",")).join("\r\n");
}

/** Saves text as a file. A BOM makes Excel read UTF-8 (Arabic/Gujarati names) correctly. */
export function downloadTextFile(
  filename: string,
  content: string,
  type = "text/csv;charset=utf-8"
): void {
  const blob = new Blob([String.fromCharCode(BOM_CODE), content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
